import React from "react";
import { Form, Select, Space, Table } from "antd";
import { EvaluationViewpointDetail } from "./ScoringPage";
import { setPersonNodes, setSummary } from "./ScoringTable1";
import { ScoringTableProps } from "./ScoringTable";
import { Messages } from "../Common/ValidateMessages";
const { Option } = Select;

export const ScoringTable9 = ({
  showPersonInfo,
  showPersonInfoItemFlags,
  useCase,
  scoringType,
  evaluations,
  applicants,
  onDocumentLinkClick,
  getFormFiledValue,
  afMap,
}: ScoringTableProps) => {
  const [columns, setColumns] = React.useState<any[]>([]);
  const [detailDatas, setDetailDatas] = React.useState<
    EvaluationViewpointDetail[]
  >([]);

  const onScoreSelectChanged = (
    v: number,
    applicantId: string,
    currentObjectId: string
  ) => {
    let sumDiv = document.querySelector(`#sum_${applicantId}`);
    let nodeList = document.querySelectorAll<HTMLInputElement>(
      `input[id^=score_${applicantId}_]`
    );
    let sum = 0;
    nodeList.forEach((node) => {
      if (node.id === currentObjectId) {
        sum = sum + v;
      } else {
        const value = getFormFiledValue!(node.id);
        if (value) sum = sum + Number(value);
      }
    });
    sumDiv!.innerHTML = String(sum);
  };

  React.useEffect(() => {
    const datas: EvaluationViewpointDetail[] = [];
    evaluations.forEach((evaluation, evaluationIndex) => {
      evaluation.evaluationViewpointDetailList.forEach(
        (detail, detailIndex) => {
          datas.push(detail);
        }
      );
    });
    setDetailDatas(datas);
    const tCloumns: any[] = [];
    tCloumns.push(
      {
        title: <div className="table-title">No</div>,
        className: "table-center-cell",
        width: "100px",
        key: `evaluationNo`,
        render: (
          value: any,
          item: EvaluationViewpointDetail,
          index: number
        ) => <span>{index + 1}</span>,
        fixed: "left",
      },
      {
        title: <div className="table-title">質問/評価項目</div>,
        width: "200px",
        key: `evaluationCriteria`,
        dataIndex: "evaluationCriteria",
        className: "multip-line-column",
        fixed: "left",
      }
    );
    if (applicants) {
      applicants.forEach((applicant, applicantIndex) => {
        const childrenCloumns: any[] = [
          {
            title: <div className="table-title">評価点</div>,
            width: "180px",
            className: "table-score-cell",
            key: `applicant_${applicantIndex}`,
            render: (
              value: any,
              item: EvaluationViewpointDetail,
              index: number
            ) => {
              const pointOptions: any[] = [];
              for (let i = item.lowScore; i <= item.highScore; i++) {
                pointOptions.push(
                  <Option key={i} value={i}>
                    {i}
                  </Option>
                );
              }
              const initValue =
                applicant.userScoringResult?.resultDetails &&
                applicant.userScoringResult?.resultDetails != null
                  ? applicant.userScoringResult?.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement &&
                        resultDetailElement != null &&
                        resultDetailElement.evaluationViewpointDetailId ===
                          item.evaluationViewpointDetailId
                    )
                  : null;
              if (useCase === "1") {
                const controlName = `score_${applicant.applicantId}_${item.evaluationViewpointDetailId}`;
                const afFlag = afMap.get(applicant.applicantId);
                return (
                  <Form.Item
                    label=""
                    name={controlName}
                    initialValue={initValue?.score}
                    rules={
                      afFlag
                        ? []
                        : [
                            {
                              required: true,
                              message: Messages["ERR-051"],
                            },
                          ]
                    }
                  >
                    <Select
                      disabled={afFlag}
                      style={{ width: "80px", fontSize: "17px" }}
                      onChange={(v: number) =>
                        onScoreSelectChanged(
                          v,
                          applicant.applicantId,
                          controlName
                        )
                      }
                    >
                      {pointOptions}
                    </Select>
                  </Form.Item>
                );
              } else if (useCase === "2") {
                const controlName = `score_${applicant.applicantId}_${item.evaluationViewpointDetailId}`;
                const resultSpans: any[] = [];
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpointDetailId ===
                        item.evaluationViewpointDetailId
                    );
                    resultSpans.push(
                      <span>
                        {scoringResult.sei}
                        {scoringResult.mei}:
                        <span className="scoreSpan">{resultDetail?.score}</span>
                      </span>
                    );
                  }
                );
                return (
                  <Space direction="vertical">
                    {resultSpans}
                    <Form.Item
                      label="確定値"
                      name={controlName}
                      initialValue={initValue?.score}
                      rules={[
                        {
                          required: true,
                          message: Messages["ERR-051"],
                        },
                      ]}
                    >
                      <Select
                        style={{ width: "80px", fontSize: "17px" }}
                        onChange={(v: number) =>
                          onScoreSelectChanged(
                            v,
                            applicant.applicantId,
                            controlName
                          )
                        }
                      >
                        {pointOptions}
                      </Select>
                    </Form.Item>
                  </Space>
                );
              } else if (useCase === "3") {
                const resultInputs: any[] = [];
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpointDetailId ===
                        item.evaluationViewpointDetailId
                    );
                    const controlName = `score_${applicant.applicantId}_${scoringResult.userId}_${item.evaluationViewpointDetailId}`;
                    resultInputs.push(
                      <Form.Item
                        label={`${scoringResult.sei}${scoringResult.mei}:`}
                        name={controlName}
                        initialValue={resultDetail?.score}
                        rules={[
                          {
                            required: true,
                            message: Messages["ERR-051"],
                          },
                        ]}
                      >
                        <Select
                          style={{ width: "80px", fontSize: "17px" }}
                          onChange={(v: number) =>
                            onScoreSelectChanged(
                              v,
                              `${applicant.applicantId}_${scoringResult.userId}`,
                              controlName
                            )
                          }
                        >
                          {pointOptions}
                        </Select>
                      </Form.Item>
                    );
                  }
                );
                return <Space direction="vertical">{resultInputs}</Space>;
              } else if (useCase === "4") {
                const resultLabels: any[] = [];
                applicant.scoringResults.forEach(
                  (scoringResult, scoringResultIndex) => {
                    const resultDetail = scoringResult.resultDetails.find(
                      (resultDetailElement) =>
                        resultDetailElement.evaluationViewpointDetailId ===
                        item.evaluationViewpointDetailId
                    );
                    resultLabels.push(
                      <span>
                        {scoringResult.sei}
                        {scoringResult.mei}:
                        <span className="scoreSpan">{resultDetail?.score}</span>
                      </span>
                    );
                  }
                );
                resultLabels.push(
                  <span className="confirmSpan">
                    確定値:
                    <span className="scoreSpan">{initValue?.score}</span>
                  </span>
                );
                return <Space direction="vertical">{resultLabels}</Space>;
              }
              return "";
            },
          },
        ];
        if (scoringType === "2" && showPersonInfo) {
          const titleNodes = setPersonNodes(
            applicant,
            scoringType,
            useCase,
            onDocumentLinkClick,
            9,
            showPersonInfoItemFlags
          );
          tCloumns.push({
            title: (
              <Space
                direction="vertical"
                align="center"
                size={0}
                style={{ width: "100%" }}
              >
                {titleNodes}
              </Space>
            ),
            key: `applicant_${applicantIndex}`,
            children: childrenCloumns,
          });
        } else {
          tCloumns.push(...childrenCloumns);
        }
      });
    }

    setColumns(tCloumns);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [evaluations, showPersonInfo, afMap]);

  return (
    <div style={{ width: "100%", textAlign: "center" }}>
      <Table
        bordered
        rowKey={(record: any) => record.evaluationViewpointDetailId}
        showSorterTooltip={false}
        columns={columns}
        dataSource={detailDatas}
        // onChange={this.onChange}
        pagination={false}
        summary={(_) => setSummary(useCase, applicants, 2, 1)}
        scroll={{ x: applicants.length > 1 ? 300 * applicants.length : true }}
      />
    </div>
  );
};
